import { Component, OnInit, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { BreadCrumbModel } from "app/views/campaign-3/models/campaign-3-breadcrumb.model";
import { ChallengeService } from "../challenge.service";
import { AccumulatorUI, ChallengeDetail, ChallengeDetailElaborated, ChallengeResponse } from "../challenge.model";
import { ActivatedRoute, Router } from "@angular/router";
import { LoyaltyAcmService } from "app/services/loyalty/loyalty-acm.service";
import { Observable } from "rxjs";
import { Acm } from "app/models/loyalty-acm.model";
import { DistributionList3 } from "app/views/campaign-3/models/campaign-3.model";
import { DistributionList3Service } from "app/views/distribution-list/services/distribution3.service";
import { Campaign3Service } from "app/views/campaign-3/services/campaign3.service";
import { MessageService } from "primeng/primeng";
import { TranslateService } from "@ngx-translate/core";
import { FormFields } from "app/views/campaign-3/components/form-fields/form-fields.component";


export interface ChallengeDetailPayload {
  challenge_id: number;
  description: string;
  flg_push_notification: '0' | '1';
  push_notification_text: string;
  long_descr: string;
}

export interface ChallengeDetailAcmPayloadEdit {
  challenge_detail_id: number;
  challenge_acm_id: number;
  min_range_value: number | null;
  max_range_value: number | null;
  challenge_detail_acm_id: number;

}


export interface ChallengeDetailAcmPayload {
  challenge_detail_id: number;
  challenge_acm_id: number;
  min_range_value: number | null;
  max_range_value: number | null;
}

export interface AccumulatorDTO {
  id: number;
  acmDescription: string;
  channelDescription: string;
  dateStart: string | Date;
  dateEnd: string | Date;
  acm_code: string;
  acmTypeDescription: string;
  challengeAcmId: number; // aggiunto per mantenere il riferimento al padre
}


@Component({
  selector: 'app-levels-creation',
  templateUrl: './levels-creation.component.html',
  styleUrls: ['./levels-creation.component.css']
})export class LevelsCreationComponent implements OnInit {

  // Form fields
  @ViewChild('descriptionFields') descriptionFields: FormFields;
  @ViewChild('pushNotify') pushNotify: FormFields;
  @ViewChild('pushNotifyText') pushNotifyText: FormFields;
  @ViewChild('descrComplete') descrComplete: FormFields;

  @ViewChildren('acmDescriptions') acmDescriptions: QueryList<FormFields>;
  @ViewChildren('minThreshold') minThresholds: QueryList<FormFields>;
  @ViewChildren('maxThreshold') maxThresholds: QueryList<FormFields>;

  fieldModel = {
    description: '',
    pushNotify: false,
    pushNotifyText: '',
    descrComplete: '',
    linkedAcm: [] as {
      id: number,
      minThreshold: number | null,
      maxThreshold: number | null,
      challengeAcmId: number,
      challenge_detail_acm_id?: number,
      acmDescription: string,
      thresholdError?: string
    }[]
  };

  show = {
    modalAcmList: false
  };

    showBreadCrumb: boolean = false;


  breadcrumbs: BreadCrumbModel[] = [];
  editMode = false;

  currentChallengeId: number;
  currentLevelId: number;
  currentLevel: ChallengeDetailElaborated;

  listAccumulator: AccumulatorUI[] = [];
  touchpointList: any[] = [];
  distributionList: DistributionList3[] = [];

  challengeDetailPayload: ChallengeDetailPayload;
  challengeDetailAcmPayload: ChallengeDetailAcmPayload[];
showLevelsTable: boolean = false;
  readOnly: boolean;

  constructor(
    private challengeService: ChallengeService,
    private distributionService: DistributionList3Service,
    private srvLoyaltyAcm: LoyaltyAcmService,
    private srvNotify: MessageService,
    private translate: TranslateService,
    private srvTranslate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    public campaignService: Campaign3Service
  ) {}

  get canSave(): boolean {
    return this.fieldModel.linkedAcm && this.fieldModel.linkedAcm.length > 0;
  }

  ngOnInit(): void {
    this.loadParams();
    this.loadLists();
  }

  challengeDetailList:ChallengeDetail[]= [] 
  challengeDetailListElaborated: ChallengeDetailElaborated[] = [];
  fetchChallengeList(id:number): void {
    this.challengeService.getCampaignChallengeDetails(id).subscribe(
      (res: ChallengeDetail[]) => {
        this.challengeDetailList = res; // dati raw      
        this.challengeDetailListElaborated = this.elaborateChallengeDetails(res);
              this.showLevelsTable = this.challengeDetailListElaborated.length > 0;




        //qui dentro devo fare vedere quei dati
      },
      (error) => {
        console.error('Errore durante il recupero di azioni delle campagne:', error);
      }
    );
  }

private elaborateChallengeDetails(details: ChallengeDetail[]): ChallengeDetailElaborated[] {
  const elaborated: ChallengeDetailElaborated[] = [];

  details.forEach(detail => {

    // Se manca challengeDetailAcm, lo tratto come array vuoto
    const acmList = detail.challengeDetailAcm ? detail.challengeDetailAcm : [];

    acmList.forEach(acm => {

      // Protezione di tutti i livelli annidati per evitare undefined
      const challengeAcm = acm && acm.challengeAcm ? acm.challengeAcm : null;
      const acmIdObj = challengeAcm && challengeAcm.acmId ? challengeAcm.acmId : null;

      const acmDescription = acmIdObj && acmIdObj.description ? acmIdObj.description : '';
      const controlAcm = acmIdObj && acmIdObj.id ? acmIdObj.id : null;

      elaborated.push({
        id: detail.id ? detail.id : null,
        challengeId: detail.challengeId ? detail.challengeId : null,
        levelName: detail.description ? detail.description : '',
        challengeDetailAcmId: acm && acm.id ? acm.id : null,
        acmDescription: acmDescription,
        controlAcm: controlAcm,
        minimumTrashold: acm && acm.minRangeValue ? acm.minRangeValue : null,
        maximumTrashold: acm && acm.maxRangeValue ? acm.maxRangeValue : null,
        pushNotify: detail.flgPushNotification ? detail.flgPushNotification : '0',
        pushNotifyText: detail.pushNotificationText ? detail.pushNotificationText : '',
        numRewards: detail.numRewards ? detail.numRewards : null
      });

    });

  });

  return elaborated;
}


private loadParams(): void {
  const challengeIdParam = this.route.snapshot.queryParamMap.get('challengeId');
  const levelIdParam = this.route.snapshot.queryParamMap.get('id');
  const readOnlyParam = this.route.snapshot.queryParamMap.get('readOnly');

  const challengeId = challengeIdParam ? Number(challengeIdParam) : null;
  const levelId = levelIdParam ? Number(levelIdParam) : null;

  // readOnly è un flag indipendente
  this.readOnly = readOnlyParam === 'true';

  if (!challengeId) {
    this.router.navigate(['/challenge-list']);
    return;
  }

  this.currentChallengeId = challengeId;

  // carico gli altri livelli
  this.fetchChallengeList(this.currentChallengeId);

  if (levelId) {
    this.currentLevelId = levelId;
    this.editMode = true;   // <-- resta invariato, dipende solo dalla presenza del livello

    this.challengeService.getCampaignChallengeDetailsForEdit(challengeId, levelId)
      .subscribe(res => {
        if (res && res[0]) {
          this.initForm(res[0]);

          // se sono in sola visualizzazione disabilito tutto
          /* if (this.readOnly && this.formGroup) {
            this.formGroup.disable({ emitEvent: false });
          } */
        }
      });

  } else {
    this.editMode = false;
  }
}

  private loadLists(): void {
    const listAcc = this.challengeService.getChallengeAcm(this.currentChallengeId);
    const distrList = this.distributionService.list();
    const touchList = this.challengeService.getTouchPoints();

    Observable.zip(listAcc, distrList, touchList).subscribe(([res_acc, distrListData, touchListData]) => {
      if (res_acc) {
        this.listAccumulator = res_acc.map((challengeAcm: any) => {
          const acm = challengeAcm.acmId;
          return {
            id: acm.id,
            acmDescription: acm.description,
            channelDescription: acm.description,
            dateStart: acm.dateStart,
            dateEnd: acm.dateEnd,
            acm_code: acm.acmCode,
            acmTypeDescription: acm.acmType.description,
            challengeAcmId: challengeAcm.id
          };
        });
      }

      if (distrListData) {
        this.distributionList = distrListData.data;
      }

      if (touchListData) {
        this.touchpointList = touchListData.map(t => Object.assign({}, t, { active: false }));
      }

      this.initBreadCrumbs();
    });
  }

  private initForm(res: ChallengeDetail): void {
    this.fieldModel.description = res.description || '';
    this.fieldModel.pushNotify = res.flgPushNotification === '1';
    this.fieldModel.pushNotifyText = res.pushNotificationText || '';
    this.fieldModel.descrComplete = res.longDescr || '';
    this.fieldModel.linkedAcm = [];

    if (res.challengeDetailAcm) {
      for (let i = 0; i < res.challengeDetailAcm.length; i++) {
        const acm = res.challengeDetailAcm[i];
        if (acm && acm.challengeAcm && acm.challengeAcm.acmId) {
          this.fieldModel.linkedAcm.push({
            id: acm.challengeAcm.acmId.id,
            minThreshold: acm.minRangeValue,
            maxThreshold: acm.maxRangeValue,
            challengeAcmId: acm.challengeAcm.id,
            challenge_detail_acm_id: acm.id,
            acmDescription: acm.challengeAcm.acmId.description
          });
        }
      }
    }
  }

  private initBreadCrumbs(): void {
    this.breadcrumbs = [
      { code: 'bc1', description: 'Challenge List', routerLink: '/challenge-list' },
      { code: 'bc2', description: 'Creazione/Modifica', routerLink: '/levels-creation' }
    ].map(bc => {
      const breadcrumb = new BreadCrumbModel();
      breadcrumb.code = bc.code;
      breadcrumb.description = bc.description;
      breadcrumb.routerLink = bc.routerLink;
      return breadcrumb;
    });
    this.showBreadCrumb=true;
  }

  breadcrumbClicked(breadcrumb: BreadCrumbModel) {
    if (breadcrumb.routerLink) {
      this.router.navigate([breadcrumb.routerLink]);
    }
  }

  onBackAction(): void {
       this.router.navigate(['/challenge-list'], {
        queryParams: { challengeId: this.currentChallengeId }
      });
  }

  onPushNotifyChange(active: boolean) {
    if (!active) {
      this.fieldModel.pushNotifyText = null;
    }
  }
performValidation(): boolean {
  let error = false;

  // -------------------------------------------------------
  // VALIDAZIONE CAMPI STATICI
  // -------------------------------------------------------
  if (this.descriptionFields) this.descriptionFields.performValidation();
  if (this.pushNotify) this.pushNotify.performValidation();
  if (this.pushNotifyText) this.pushNotifyText.performValidation();
  if (this.descrComplete) this.descrComplete.performValidation();

  if ((this.descriptionFields && !this.descriptionFields.valid) ||
      (this.pushNotify && !this.pushNotify.valid) ||
      (this.pushNotifyText && !this.pushNotifyText.valid) ||
      (this.descrComplete && !this.descrComplete.valid)) {
    error = true;
  }

  // -------------------------------------------------------
  // VALIDAZIONE CAMPI DINAMICI (linkedAcm)
  // -------------------------------------------------------
  for (var i = 0; i < this.fieldModel.linkedAcm.length; i++) {
    var acm = this.fieldModel.linkedAcm[i];

    // Reset errore threshold
    acm.thresholdError = null;

    // ------------------------
    // 1) VALIDAZIONE UI FIELDS
    // ------------------------

    // description
    const descField = this.acmDescriptions.toArray()[i];
    if (descField) {
      descField.performValidation();
      if (!descField.valid) error = true;
    }

    // minThreshold
    const minField = this.minThresholds.toArray()[i];
    if (minField) {
      minField.performValidation();
      if (!minField.valid) error = true;
    }

    // maxThreshold
    const maxField = this.maxThresholds.toArray()[i];
    if (maxField) {
      maxField.performValidation();
      if (!maxField.valid) error = true;
    }

    // ------------------------
    // 2) VALIDAZIONE LOGICA
    // ------------------------

    // Descrizione obbligatoria
    if (!acm.acmDescription) {
      error = true;
    }

    // minThreshold obbligatorio
    if (acm.minThreshold === null || acm.minThreshold === undefined || isNaN(acm.minThreshold)) {
      error = true;
      acm.thresholdError = this.srvTranslate.instant('challenge.min_threshold_required');
      continue;
    }

    // minThreshold non può essere negativo
    if (acm.minThreshold < 0) {
      error = true;
      acm.thresholdError = this.srvTranslate.instant('challenge.min_threshold_invalid');
      continue;
    }

    // maxThreshold FACOLTATIVO
    if (acm.maxThreshold !== null && acm.maxThreshold !== undefined && !isNaN(acm.maxThreshold)) {

      // Se presente → deve essere maggiore di minThreshold
      if (acm.minThreshold >= acm.maxThreshold) {
        error = true;
        acm.thresholdError = this.srvTranslate.instant('challenge.threshold_error');
        continue;
      }
    }
  }

  return !error;
}


  //test
onAddAccumulator(): void {

  if (this.listAccumulator && this.fieldModel && this.fieldModel.linkedAcm) {

    for (let i = 0; i < this.listAccumulator.length; i++) {
      let acm = this.listAccumulator[i];
      let selected = false;

      for (let j = 0; j < this.fieldModel.linkedAcm.length; j++) {
        if (this.fieldModel.linkedAcm[j].id === acm.id) {
          selected = true;
          break;
        }
      }

      acm.rowSelected = selected;
    }
  }

  this.show.modalAcmList = true;
}

onAcmSelected(listAcm: Array<any>) {
  if (!listAcm) listAcm = [];

  // Rimuovo dal padre quelli che non sono più selezionati
  this.fieldModel.linkedAcm = this.fieldModel.linkedAcm.filter(
    existing => listAcm.some(acm => acm.id === existing.id)
  );

  // Aggiungo quelli nuovi
  for (const acm of listAcm) {
    if (!this.fieldModel.linkedAcm.some(x => x.id === acm.id)) {
      this.fieldModel.linkedAcm.push({
        id: acm.id,
        minThreshold: null,
        maxThreshold: null,
        challengeAcmId: acm.challengeAcmId,
        acmDescription: acm.acmDescription
      });
    }
  }

  this.show.modalAcmList = false;
}


  removeAccumulatorACM(index: number) {
    if (index > -1 && index < this.fieldModel.linkedAcm.length) {
      this.fieldModel.linkedAcm.splice(index, 1);
    }
  }

  createFirstCallPayload(): ChallengeDetailPayload {
    return {
      challenge_id: this.currentChallengeId,
      description: this.fieldModel.description,
      flg_push_notification: this.fieldModel.pushNotify ? '1' : '0',
      push_notification_text: this.fieldModel.pushNotifyText || '',
      long_descr: this.fieldModel.descrComplete || ''
    };
  }

  createSecondCallPayload(levelId: number): ChallengeDetailAcmPayload[] {
    const result: ChallengeDetailAcmPayload[] = [];
    for (let i = 0; i < this.fieldModel.linkedAcm.length; i++) {
      const acm = this.fieldModel.linkedAcm[i];
      result.push({
        challenge_detail_id: levelId,
        challenge_acm_id: acm.challengeAcmId,
        min_range_value: acm.minThreshold !== undefined && acm.minThreshold !== null ? acm.minThreshold : null,
        max_range_value: acm.maxThreshold !== undefined && acm.maxThreshold !== null ? acm.maxThreshold : null
      });
    }
    return result;
  }

  createSecondCallPayloadEdit(levelId: number): ChallengeDetailAcmPayloadEdit[] {
    const result: ChallengeDetailAcmPayloadEdit[] = [];
    for (let i = 0; i < this.fieldModel.linkedAcm.length; i++) {
      const acm = this.fieldModel.linkedAcm[i];
      result.push({
        challenge_detail_id: levelId,
        challenge_acm_id: acm.challengeAcmId,
        challenge_detail_acm_id: acm.challenge_detail_acm_id,
        min_range_value: acm.minThreshold !== undefined && acm.minThreshold !== null ? acm.minThreshold : null,
        max_range_value: acm.maxThreshold !== undefined && acm.maxThreshold !== null ? acm.maxThreshold : null
      });
    }
    return result;
  }



onSaveLevel() {
  // Validazione
  const isFormValid = this.performValidation();
  if (!isFormValid) {
    console.error('Validazione fallita: alcuni campi non sono validi');
    return;
  }

  // Crea payload unificato
  const payload = this.createUnifiedPayload();
  // Determina se chiamare CREATE o UPDATE
  //TODO
  const request$ = this.editMode
    ? this.challengeService.updateLevelWithAcm(this.currentLevelId, payload)
    : this.challengeService.createLevelWithAcm(payload);

  request$.subscribe({
    next: (res: any) => {
      console.log('Livello + ACM salvati:', res);

      this.srvNotify.add({
        severity: 'success',
        summary: this.srvTranslate.instant('common.success'),
        detail: this.editMode
          ? this.srvTranslate.instant('challenge.levelUpdate')
          : this.srvTranslate.instant('challenge.levelCreation')
      });

      this.router.navigate(['/challenge-list'], {
        queryParams: { challengeId: this.currentChallengeId }
      });
    },
    error: err => {
      console.error('Errore durante il salvataggio del livello + ACM:', err);
    }
  });
}
private createUnifiedPayload(): any {
  // --- DETAIL ---
  const detail = {
    challenge_id: this.currentChallengeId,
    description: this.fieldModel.description,
    flg_push_notification: this.fieldModel.pushNotify ? '1' : '0',
    push_notification_text: this.fieldModel.pushNotifyText || '',
    long_descr: this.fieldModel.descrComplete || ''
  };

  // --- ACM LIST (editMode gestisce se includere l'id di relazione) ---
  const acmList = [];

  for (let i = 0; i < this.fieldModel.linkedAcm.length; i++) {
    const acm = this.fieldModel.linkedAcm[i];

    const acmPayload: any = {
      challenge_acm_id: acm.challengeAcmId,
      min_range_value: acm.minThreshold !== undefined && acm.minThreshold !== null ? acm.minThreshold : null,
      max_range_value: acm.maxThreshold !== undefined && acm.maxThreshold !== null ? acm.maxThreshold : null
    };

    // In EDIT mode aggiungo anche l'id della relazione
    if (this.editMode) {
      acmPayload.challenge_detail_acm_id = acm.challenge_detail_acm_id;
    }

    acmList.push(acmPayload);
  }

  return {
    detail: detail,
    acmList: acmList
  };
}

}



// WEBPACK FOOTER //
// ./src/app/views/challenge/levels-creation/levels-creation.component.ts